var _rect, _path, _path2, _circle, _rect2, _rect3, _path3, _path4, _circle2, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.45 81.0422L99.7532 196.554",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.372 148.743L172.393 82.014L138.965 135.849L216.372 148.743Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.501,
    cy: 73.8955,
    r: 8.20846,
    transform: "rotate(31.8372 175.501 73.8955)",
    stroke: "white",
    strokeWidth: 11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 186.258,
    y: 91.0099,
    width: 11.1635,
    height: 70.2644,
    transform: "rotate(39.9848 186.258 91.0099)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 204.875,
    y: 106.623,
    width: 11.1635,
    height: 70.2644,
    transform: "rotate(39.9848 204.875 106.623)",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4933 81.0422L159.511 196.554",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5714 148.743L83.5507 82.014L116.978 135.849L39.5714 148.743Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.20846,
    cy: 8.20846,
    r: 8.20846,
    transform: "matrix(-0.849551 0.527507 0.527507 0.849551 83.0857 62.592)",
    stroke: "white",
    strokeWidth: 11
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11.1635,
    height: 69.6967,
    transform: "matrix(-0.766215 0.642584 0.642584 0.766215 69.5627 90.8291)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11.1635,
    height: 53.0616,
    transform: "matrix(-0.766215 0.642584 0.642584 0.766215 51.0684 106.623)",
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyLogo);
export default __webpack_public_path__ + "static/media/party-logo.46086ec1de8533291a3e41926b0b9ddf.svg";
export { ForwardRef as ReactComponent };